import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import ShowMoreText from "../../../components/shared/show-more";
import { portDefaultValues } from "../../../lib/constants";
import { useGetForm } from "../../../lib/queries/queriesAndMutations";
import { getImage, toLocaleStringFormatter, unixToPersianDay } from "../../../utils/utils";
import FormImageUploader from "./FormImageUploader";

export default function FormPage({ close, userId, businessType, businessId }) {
  const { mutateAsync: getForm } = useGetForm();
  const [formData, setFormData] = useState(portDefaultValues);
  const { id } = useParams();
  if (id == "new") {
    return;
  }
  const disabled = false;

  useEffect(() => {
    let isMounted = true; // Flag to track if the component is still mounted

    const handleGetForm = async () => {
      try {
        const response = await getForm(id); // Make sure to await the async call
        if (isMounted && response.status === 200) {
          setFormData(response.data.form);
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    };

    handleGetForm();

    return () => {
      isMounted = false; // Cleanup function to set the flag to false on unmount
    };
  }, [id]);

  return (
    <div className="  w-full overflow-scroll max-h-[85vh] vanda rounded-md  flex flex-col gap-4  p-2 bg-white pb-[100px]">
      {/* <p className="text-xl font-bold  "> مشخصات عمومی</p>
       <hr /> */}
      <div className="relative w-full flex flex-col items-center md:flex-row gap-4  bg-gradient-to-r from-green to-dark   p-6 rounded-md ">
        <FormImageUploader
          className={"rounded-sm"}
          src={getImage(formData?.image_preview)}
          width={"120px"}
          heigh={"70px"}
        />
        {/* <img src={formData?.image} alt="" className="w-24 h-24" /> */}
        <FormPageCard title={"نام فرم"}>{formData?.name}</FormPageCard>

        <FormPageCard title={"لینک فرم"}>
          <Link target="_blank" rel="stylesheet" to={`${import.meta.env.VITE_FORM_URL}/f/${formData?.link}`}>
            {`${import.meta.env.VITE_FORM_URL}/f/${formData?.link}`}
          </Link>
        </FormPageCard>

        {formData?.expire_time && (
          <FormPageCard title={"تاریخ انقضا"}>{unixToPersianDay(formData?.expire_time)}</FormPageCard>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2  gap-[4px]">
        <div className="col-span-2 ">
          <FormPageTextArea title={"شرح فرم"} value={formData?.description ?? "بدون شرح"} />
        </div>
      </div>
      <p className="text-xl font-bold  "> امورمالی</p>
      <hr />
      <div className="grid grid-cols-1 md:grid-cols-2  gap-[8px]">
        <div className="col-span-1 ">
          <FormPageAmountCard
            title={"مبلغ فرم"}
            value={formData?.form_amount ? `${toLocaleStringFormatter(formData?.form_amount)} ریال` : ""}
            fixed={formData?.fixed_amount}
          />
        </div>
        <div className="col-span-1 ">
          <FormPageWageCard
            title={"پرداخت کننده کارمزد"}
            value={formData?.form_amount}
            isWageOnOwner={formData?.is_wage_on_owner}
          />
        </div>
      </div>
      <p className="text-xl font-bold  "> تنظیم ورودی ها</p>
      <hr />

      <div className="grid grid-cols-1 md:grid-cols-2  gap-[16px]">
        {formData?.display_payer_name && (
          <div className="col-span-1 ">
            <FormPageOptionCard
              isRequired={formData?.is_payer_name_mandatory}
              isActive={formData?.display_payer_name}
              title={"نمایش ورودی نام پرداخت‌کننده در فرم"}
              CheckboxName={"display_payer_name"}
              OptionName={"is_payer_name_mandatory"}
            />
          </div>
        )}
        {formData?.display_payer_phone && (
          <div className="col-span-1 ">
            <FormPageOptionCard
              isRequired={formData?.is_payer_phone_mandatory}
              isActive={formData?.display_payer_phone}
              disabled={disabled}
              title={"نمایش  شماره همراه پرداخت‌کننده در فرم"}
              CheckboxName={"display_payer_phone"}
              OptionName={"is_payer_phone_mandatory"}
            />
          </div>
        )}
        {formData?.display_payer_email && (
          <div className="col-span-1 ">
            <FormPageOptionCard
              isRequired={formData?.is_payer_email_mandatory}
              isActive={formData?.display_payer_email}
              disabled={disabled}
              title={"نمایش  ایمیل پرداخت‌کننده در فرم"}
              CheckboxName={"display_payer_email"}
              OptionName={"is_payer_email_mandatory"}
            />
          </div>
        )}
        {formData?.display_payer_address && (
          <div className="col-span-1 ">
            <FormPageOptionCard
              isRequired={formData?.is_payer_address_mandatory}
              isActive={formData?.display_payer_address}
              disabled={disabled}
              title={"نمایش  آدرس پرداخت‌کننده در فرم"}
              CheckboxName={"display_payer_address"}
              OptionName={"is_payer_address_mandatory"}
            />
          </div>
        )}
        {formData?.display_national_code && (
          <div className="col-span-1 ">
            <FormPageOptionCard
              isRequired={formData?.is_national_code_mandatory}
              isActive={formData?.display_national_code}
              disabled={disabled}
              title={"نمایش  کدملی پرداخت‌کننده در فرم"}
              CheckboxName={"display_national_code"}
              OptionName={"is_national_code_mandatory"}
            />
          </div>
        )}
        {formData?.display_postal_code && (
          <div className="col-span-1 ">
            <FormPageOptionCard
              isRequired={formData?.is_postal_code_mandatory}
              isActive={formData?.display_postal_code}
              title={"نمایش  کدپستی پرداخت‌کننده در فرم"}
              CheckboxName={"display_postal_code"}
              OptionName={"is_postal_code_mandatory"}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const FormPageCard = ({ title, children }) => {
  return (
    <div className="text-white flex flex-col gap-2  p-2  bg-glass w-fit    rounded-md ">
      <p className="text-[10px] md:text-[12px] text-neutral-20 font-semibold">{title}</p>
      <div className="text-[14px] md:text-[16px] text-white font-semibold mx-auto">{children}</div>
    </div>
  );
};
const FormPageTextArea = ({ title, value }) => {
  return (
    <div className="text-gray-500 flex flex-col gap-2  p-2 bg-neutral-20  ">
      <p className="text-[12px] md:text-[14px] text-neutral-70 font-semibold">{title}</p>
      <ShowMoreText
        lines={3}
        more="نمایش بیشتر"
        less="نمایش کمتر"
        className="bg-white break-words p-2 "
        anchorClass="text-dark cursor-pointer text-[10px] "
        expanded={false}
        width={0}
        truncatedEndingComponent={"... "}
      >
        {value || ""}
      </ShowMoreText>
    </div>
  );
};

const FormPageOptionCard = ({ title, isActive, isRequired }) => {
  return (
    <div className="text-gray-500 flex justify-between  gap-2  p-2 bg-neutral-20 shadow-xl   ">
      <div className="flex gap-1">
        <CheckIcon isActive={isActive} />
        <p className="text-[12px] md:text-[14px] text-neutral-70 ">{title}</p>
      </div>

      <div
        className={`text-[13px] md:text-[16px] ${
          isRequired ? "bg-secondary-10" : ""
        } text-secondary-90 px-2 rounded-md`}
      >
        {isRequired ? "اجباری" : "اختیاری"}
      </div>
    </div>
  );
};
const CheckIcon = ({ isActive }) => {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L12.0243 14.3899C11.4586 14.9556 10.5414 14.9556 9.97568 14.3899L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z"
        fill={isActive ? "green" : "red"}
      />
    </svg>
  );
};

const FormPageAmountCard = ({ title, fixed, value }) => {
  return (
    <div className="text-gray-500 flex flex-col gap-2  p-2 bg-neutral-20 shadow-xl truncate h-full ">
      <p className="text-[12px] md:text-[14px] text-neutral-70 font-semibold">{title}</p>
      <div className=" flex justify-center w-full gap-2 h-full ">
        <div
          className={`text-[13px] md:text-[16px] w-fit  ${
            fixed ? "bg-secondary-10" : ""
          } text-secondary-90 px-2 rounded-md`}
        >
          {fixed ? "ثابت" : "متغیر"}
        </div>
        <p className="text-[16px] md:text-[18px] text-dark font-semibold ">{value}</p>
      </div>
    </div>
  );
};

const FormPageWageCard = ({ title, isWageOnOwner, displayWagePayer }) => {
  return (
    <div className="text-gray-500 flex flex-col gap-2  p-2 bg-neutral-20 shadow-xl truncate ">
      <div className="flex justify-between items-center">
        <p className="text-[12px] md:text-[14px] text-neutral-70 font-semibold">{title}</p>
        <div className="text-[12px]  flex items-center gap-2 bg-neutral-10  px-2 py-1  ">
          <p>نمایش کارمزد</p>
          <div
            className={`text-[13px] md:text-[16px] w-fit  ${
              displayWagePayer ? "bg-success-10 text-success-90" : " bg-secondary-10"
            } text-secondary-90 px-2 rounded-md`}
          >
            {displayWagePayer ? "فعال" : "غیرفعال"}
          </div>
        </div>
      </div>
      <div className=" flex justify-center w-full gap-2">
        <div
          className={`text-[13px] md:text-[16px] w-fit  ${
            isWageOnOwner ? "bg-secondary-10" : ""
          } text-secondary-90 px-2 rounded-md`}
        >
          {isWageOnOwner ? "خودم" : "مشتری"}
        </div>
      </div>
    </div>
  );
};
